import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { getCustomerProfile } from '_models/redux/customer-profile/action';
import { getTicketById } from '_models/redux/get-ticket-by-id/action';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from '../../clientTickets/modal/new-inicidence';
import AvatarComponent from './AvatarComponent';

const CustomerProfileHeaderUser = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const { customerProfileReducer, getCustomerProfile } = props;
  const { customerProfile } = customerProfileReducer || {};
  const statusLine = customerProfile?.status?.subStatus;
  const { profile } = customerProfile || {};
  const { name, last_name, mothers_last_name, carrier_name, imsi, imei, icc_number, activated_at } =
    profile || {};

  useEffect(() => {
    if (profile !== undefined) setIsLoading(false);
  }, [profile]);

  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location || {};
  const { directNumber } = state || {};

  useEffect(() => {
    navigate(<Modal />, {
      state: { name, last_name, mothers_last_name, directNumber },
    });
  }, [name, last_name, mothers_last_name, directNumber, navigate]);

  useEffect(() => {
    if (directNumber !== undefined) {
      getCustomerProfile({
        directNumber: directNumber,
      });
    }
  }, [directNumber, getCustomerProfile]);

  const seeLineStatus = () => {
    switch (statusLine?.toUpperCase()) {
      case 'ACTIVE':
        return <p className='line-status'>Línea activa</p>;
      case 'IDLE':
        return <p className='line-status-Idle'>Inactivo</p>;
      case 'AOV':
        return <p className='line-status'>Activo con producto facturable</p>;
      case 'ACT':
        return <p className='line-status'>Activo sin producto facturable</p>;
      case 'SUP':
        return <p className='line-status-Suspendida'>Suspendido</p>;
      case 'BAR':
        return <p className='line-status-Barring'>Barring</p>;
      case 'PRE':
        return <p className='line-status-Predeactivate'>Predesactivo</p>;
      case 'DAC':
        return <p className='line-status-Suspendida'>Desactivado</p>;
      case 'PREACT':
        return <p className='line-status-Predeactivate'>Pre activo </p>;
      default:
        return <h1 className='line-status'>{statusLine?.toUpperCase()}</h1>;
    }
  };

  return (
    <Grid container mt={2} spacing={3}>
      <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
        <Grid container display={'flex'} flexDirection={'row'} className='basic'>
          <Grid item size={{ xs: 12 }} className='ticket-data'>
            <Grid container>
              <Grid item size={{ xs: 1 }} mr={2}>
                <AvatarComponent />
              </Grid>
              <Grid item size={{ xs: 10 }}>
                <h4>
                  {isLoading ? (
                    <CircularProgress />
                  ) : name && last_name && mothers_last_name !== 'undefined' ? (
                    name + ' ' + last_name + ' ' + mothers_last_name
                  ) : null}
                </h4>
                <p>{isLoading ? <CircularProgress /> : directNumber}</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item size={{ xs: 12, md: 6, lg: 3 }}>
        <Grid container className='ticket-data'>
          <Grid item size={{ xs: 6 }}>
            {isLoading ? <CircularProgress /> : <h4> {carrier_name}</h4>}
          </Grid>
          <Grid item size={{ xs: 6 }} display={'flex'} justifyContent={'flex-end'}>
            <p className='status'>{seeLineStatus()}</p>
          </Grid>
          <Grid item size={{ xs: 6 }}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <p className='data'>
                {' Se activó el '}
                {isLoading ? moment.unix(activated_at).format('DD/MM/YYYY') : 'N/A'}
              </p>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item size={{ xs: 6 }}>
        <Grid
          container
          className='numeric ticket-data'
          sx={{
            '& > *': { minWidth: 0 },
            '& p': { overflowWrap: 'anywhere' },
          }}
        >
          <Grid item size={{ xs: 12, sm: 4 }}>
            <h4>IMSI</h4>
            {isLoading ? <CircularProgress /> : <p> {imsi}</p>}
          </Grid>
          <Grid item size={{ xs: 12, sm: 4 }}>
            <h4>IMEI</h4>
            {isLoading ? <CircularProgress /> : <p> {imei}</p>}
          </Grid>
          <Grid item size={{ xs: 12, sm: 4 }}>
            <h4>ICC</h4>
            {isLoading ? <CircularProgress /> : <p> {icc_number}</p>}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state) => ({
  customerProfileReducer: state.customerProfile,
  ticketById: state.ticketById,
  incidence: state.incidence,
});
const mapDispatchToProps = {
  getCustomerProfile,
  getTicketById,
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomerProfileHeaderUser);
